import React from 'react';
import classNames from 'classnames';
import { IStandingsMatch, IStandingsParticipant } from 'twain-sport-fe-mono/interfaces';
import { useParticipantsByCode } from 'twain-sport-fe-mono/hooks/useParticipantsByCode';
import { StandingsMatch } from '../StandingsMatch';
import classes from './StandingsPlayoffs.module.scss';

interface IProps {
    participants: IStandingsParticipant[];
    matches: IStandingsMatch[];
}

export const StandingsPlayoffs: React.FC<IProps> = (props) => {
    const participantsByCode = useParticipantsByCode(props.participants);

    return (
        <div className={classes.container}>
            {props.matches.map((match, index) => (
                <StandingsMatch
                    key={match.code}
                    participants={{
                        left: match.participants.left?.code
                            ? participantsByCode[match.participants.left.code]
                            : null,
                        right: match.participants?.right
                            ? participantsByCode[match.participants.right.code]
                            : null,
                    }}
                    match={match}
                    className={classNames(classes.match, {
                        [classes.matchesPath]: index % 2,
                        [classes.matchesWithPath]: props.matches.length > 1,
                    })}
                    fullInfo
                />
            ))}
        </div>
    );
};
